import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/next/src/app/[locale]/error.tsx");
